import { participantConstants } from "../_constants";

const initialState = {
  participants: null,
  currentParticipant: null,
  allParticipantsLoading: false,
  allParticipantsError: null,
  addParticipantLoading: false,
  addParticipantError: null,
  viewParticipantLoading: false,
  viewParticipantError: null,
  editParticipantLoading: false,
  editParticipantError: null,
};

const {
  GET_ALL_PARTICIPANTS_START,
  GET_ALL_PARTICIPANTS_SUCCESS,
  GET_ALL_PARTICIPANTS_FAILED,
  ADD_PARTICIPANT_START,
  ADD_PARTICIPANT_END,
  ADD_PARTICIPANT_FAILED,
  VIEW_PARTICIPANT_START,
  VIEW_PARTICIPANT_SUCCESS,
  VIEW_PARTICIPANT_FAILED,
  EDIT_PARTICIPANT_START,
  EDIT_PARTICIPANT_END,
  EDIT_PARTICIPANT_SUCCESS,
  EDIT_PARTICIPANT_FAILED,
} = participantConstants;

export default function participantReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_PARTICIPANTS_START:
      return {
        ...state,
        allParticipantsLoading: true,
      };
    case GET_ALL_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        allParticipantsLoading: false,
        participants: action.payload,
      };
    case GET_ALL_PARTICIPANTS_FAILED:
      return {
        ...state,
        allParticipantsLoading: false,
        allParticipantsError: action.payload,
      };
    case ADD_PARTICIPANT_START:
      return {
        ...state,
        addParticipantLoading: true,
      };
    case ADD_PARTICIPANT_END:
      return {
        ...state,
        addParticipantLoading: false,
      };
    case ADD_PARTICIPANT_FAILED:
      return {
        ...state,
        addParticipantLoading: false,
        addParticipantError: action.payload,
      };
    case VIEW_PARTICIPANT_START:
      return {
        ...state,
        viewParticipantLoading: true,
      };
    case VIEW_PARTICIPANT_SUCCESS:
      return {
        ...state,
        viewParticipantLoading: false,
        currentParticipant: action.payload,
      };
    case VIEW_PARTICIPANT_FAILED:
      return {
        ...state,
        viewParticipantLoading: false,
        viewParticipantError: action.payload,
      };
    case EDIT_PARTICIPANT_START:
      return {
        ...state,
        editParticipantLoading: true,
      };
    case EDIT_PARTICIPANT_END:
      return {
        ...state,
        editParticipantLoading: false,
      };
    case EDIT_PARTICIPANT_SUCCESS:
      return {
        ...state,
        editParticipantLoading: false,
        currentParticipant: action.payload,
      };
    case EDIT_PARTICIPANT_FAILED:
      return {
        ...state,
        editParticipantLoading: false,
        editParticipantError: action.payload,
      };
    default:
      return state;
  }
}
